<template>
  <DetermineEligibility />
</template>

<script>
import DetermineEligibility from '@/components/DetermineEligibility.vue';
export default {
  name: "Home",
  components: {
    DetermineEligibility
  },
};
</script>
